/**
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { IEditor } from "../../IEditor";

export function registerMenus(dc: IEditor): void {
	const menuSvc = dc.get("menuService");

	menuSvc.registerMenuItem("main.tools", {
		id: "openDocumentation",
		label: "Documentation",
		tooltip: "Open the Adapptio Documentation.",
		icon: "mdi/book",
		flags: [],
		order: 51,
		commandId: "documentation.open"
	});
}
